export function formatProductCardTag(value) {
  if (!value) return value;

  const normalized = value.replace(/-/g, " ").toLowerCase();
  if (normalized === "hormone replacement therapy") return "HRT";
  if (normalized === "cardiology heart blood pressure") return "Cardiology";

  return value
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => (word ? `${word[0].toUpperCase()}${word.slice(1)}` : ""))
    .join(" ");
}
